import {first} from '@shared/helpers/array'
import {formatISO} from '@shared/helpers/date'

import {getSaleHistoryDetailByApi} from '@web/actions/saleHistory'
import {decodeHtmlEntities} from '@web/helpers/htmlEntities'
import {getInitialState} from '@web/slices/transactionHistory/slice'
import makeSlice from '@web/slices/transactionHistory/sliceMaker'

const transactionHistorySlice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(getSaleHistoryDetailByApi.pending, () => {
                return getInitialState()
            })
            .addCase(getSaleHistoryDetailByApi.fulfilled, (state, {payload}) => {
                const {
                    detail: {productOrders},
                } = payload
                const product = first(productOrders)

                const operationHistories = product?.operationHistories

                if (operationHistories) {
                    state.items = operationHistories.map(({operationName, operationDateTime, operationContents}) => {
                        return {
                            name: operationName,
                            date: formatISO(operationDateTime),
                            description: decodeHtmlEntities(operationContents),
                        }
                    })
                }
            })
    },
})

export default transactionHistorySlice.reducer
